import { updateIncludeStart} from '@process-advisor/process-miner/processMiner/processMiner';

export type IncludeStartProps = {
    includeStart?: boolean;
}

export const changeIncludeStart = ({ includeStart}: IncludeStartProps) =>
    updateIncludeStart({ includeStart });
